export default __webpack_public_path__ + "static/media/icon-circle-security-header.8dbb9a09.svg";